import React from 'react';
import { cn } from '../../utils/cn';
import { BoldText, Text } from '../Text/Text';
import { mergeProps } from '@react-aria/utils';
import { filterComponentProps } from '../../utils/filterComponentProps';
export function Notice({ children, title, subtitle, action, ...extra }) {
    return (React.createElement("div", Object.assign({}, mergeProps(filterComponentProps(extra), {
        className: cn('relative bg-gesso', 'flex flex-col'),
    })),
        React.createElement("div", { className: cn('flex-1 flex flex-col items-center', 'my-8 space-y-4') },
            React.createElement("div", { className: cn('mx-4') },
                React.createElement(BoldText, { className: cn('text-center') }, title),
                React.createElement(Text, { className: cn('text-center') }, subtitle)),
            children,
            action && React.createElement("div", { className: cn('mx-4') }, action))));
}
